
export default function Terms() {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white shadow-sm">
        <div className="container mx-auto px-6 lg:px-20 py-4">
          <div className="flex items-center justify-between">
            <img
              src="https://static.readdy.ai/image/482db82fa6135662cb175aa58592a390/0f90afccf080785d3f48ab4b9d5a5a73.png"
              alt="8028 Private Salon"
              className="h-8 w-auto"
            />
            <nav>
              <a
                href="/"
                className="text-gray-600 hover:text-[#EF9786] transition-colors cursor-pointer"
              >
                ホームに戻る
              </a>
            </nav>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="py-12">
        <div className="container mx-auto px-6 lg:px-20 max-w-4xl">
          <h1 className="text-3xl font-bold text-gray-800 mb-6">8028 GLOBAL SALON 予約サービス 利用規約</h1>
          <p className="text-sm text-gray-600 mb-8">最終更新日：2025年5月2日</p>
          
          <div className="prose max-w-none">
            <p className="text-gray-700 mb-8 leading-relaxed">
              8028 GLOBAL株式会社（以下「当社」といいます。）は、当社が運営するマッチングプラットフォーム「8028 GLOBAL SALON」（以下「本サービス」といいます。）に関し、以下のとおり利用規約（以下「本規約」といいます。）を定めます。本サービスを利用する前に本規約をよくお読みいただき、同意のうえでご利用ください。
            </p>

            <section className="mb-8">
              <h2 className="text-xl font-bold text-gray-800 mb-4">第1条（適用）</h2>
              <ol className="list-decimal pl-6 space-y-2 text-gray-700">
                <li>本規約は、本サービスの利用に関する当社とユーザーとの一切の関係に適用されます。</li>
                <li>当社がウェブサイト等で掲載するガイドライン、キャンセルポリシー、プライバシーポリシー、特定商取引法表示その他の個別規定（以下「個別規定」）は、本規約の一部を構成します。</li>
                <li>本規約と個別規定が矛盾抵触する場合は、個別規定に別段の定めがない限り本規約が優先します。</li>
              </ol>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-bold text-gray-800 mb-4">第2条（定義）</h2>
              <p className="text-gray-700 mb-3">本規約において用いる用語の定義は次のとおりとします。</p>
              <div className="bg-gray-50 p-6 rounded-lg">
                <dl className="space-y-4">
                  <div>
                    <dt className="font-semibold text-gray-800">サロン：</dt>
                    <dd className="text-gray-700 ml-4">本サービスに登録し、8028 予防メンテナンスを提供する歯科医院または提携施設。</dd>
                  </div>
                  <div>
                    <dt className="font-semibold text-gray-800">歯科衛生士（DH）：</dt>
                    <dd className="text-gray-700 ml-4">国家資格を有し、8028 GLOBAL SALON に登録されたサロン（歯科医院または提携施術施設）に所属して施術を行う者。</dd>
                  </div>
                  <div>
                    <dt className="font-semibold text-gray-800">ラーニングプログラム：</dt>
                    <dd className="text-gray-700 ml-4">当社が提供するオンライン研修教材・ライブ講座・評価試験の総称。</dd>
                  </div>
                  <div>
                    <dt className="font-semibold text-gray-800">ユーザー：</dt>
                    <dd className="text-gray-700 ml-4">本サービスを通じてチケットを購入し施術を受ける者。</dd>
                  </div>
                  <div>
                    <dt className="font-semibold text-gray-800">チケット：</dt>
                    <dd className="text-gray-700 ml-4">ユーザーが施術を受ける権利を回数券方式で購入する電子商品。</dd>
                  </div>
                  <div>
                    <dt className="font-semibold text-gray-800">予約契約：</dt>
                    <dd className="text-gray-700 ml-4">ユーザーがチケットを消費して DH に対し施術提供を申し込むことで成立する契約。</dd>
                  </div>
                  <div>
                    <dt className="font-semibold text-gray-800">報酬：</dt>
                    <dd className="text-gray-700 ml-4">DH およびサロンに対し当社が分配する施術代金等。</dd>
                  </div>
                  <div>
                    <dt className="font-semibold text-gray-800">投稿コンテンツ：</dt>
                    <dd className="text-gray-700 ml-4">レビュー・コメント・画像等、ユーザーが本サービスに投稿する情報。</dd>
                  </div>
                </dl>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-bold text-gray-800 mb-4">第3条（利用登録）</h2>
              <ol className="list-decimal pl-6 space-y-2 text-gray-700">
                <li>ユーザーは、本規約に同意のうえ、当社所定の方法でアカウント登録を行うことで本サービスを利用できます。</li>
                <li>当社は、以下のいずれかに該当すると判断した場合、登録を拒否し、または後に抹消することがあります。
                  <ul className="list-disc pl-6 mt-2 space-y-1">
                    <li>登録情報に虚偽・誤記・記載漏れがある場合</li>
                    <li>未成年者が法定代理人の同意なく登録した場合</li>
                    <li>反社会的勢力である、または関係を有する場合</li>
                    <li>利用停止歴・規約違反歴がある場合</li>
                    <li>その他、当社が不適切と判断した場合</li>
                  </ul>
                </li>
              </ol>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-bold text-gray-800 mb-4">第4条（チケットの購入・有効期限）</h2>
              <ol className="list-decimal pl-6 space-y-2 text-gray-700">
                <li>チケットの価格、販売単位、支払方法は当社が別途表示する内容によります。</li>
                <li>購入後のチケットは理由の如何を問わず返品・返金できません。</li>
                <li>チケットの有効期限は購入日から180日とし、期限経過後は失効します。失効したチケットの返金・振替は行いません。</li>
                <li>チケットはユーザー本人のみ利用できます。譲渡・転売・換金その他第三者利用を禁止します。</li>
              </ol>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-bold text-gray-800 mb-4">第5条（予約契約および施術料）</h2>
              <ol className="list-decimal pl-6 space-y-2 text-gray-700">
                <li>ユーザーが空き枠を選択しチケットを消費した時点で、当該DHとの間に予約契約が成立します。</li>
                <li>施術料はチケット1回分とし、追加オプションがある場合は別途当社またはサロンが定める方法で支払うものとします。</li>
                <li>施術自体はサロンに所属するDHが行い、当社は施術の当事者ではありません。</li>
              </ol>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-bold text-gray-800 mb-4">第6条（キャンセル・変更）</h2>
              <ol className="list-decimal pl-6 space-y-2 text-gray-700">
                <li>ユーザーは、マイページから予約日時の変更を 施術当日まで 行うことができます。変更操作が完了した時点で旧予約はキャンセル扱いとなり、下記キャンセル料が適用されます。</li>
                <li>キャンセル料は以下のとおりとし、チケット返金または決済取消額から当該料率相当を差し引きます。
                  <div className="bg-white border border-gray-200 rounded-lg overflow-hidden mt-3">
                    <table className="w-full">
                      <thead>
                        <tr className="bg-gray-50 border-b border-gray-200">
                          <th className="px-4 py-3 text-left font-semibold text-gray-800">キャンセル日時</th>
                          <th className="px-4 py-3 text-left font-semibold text-gray-800">キャンセル料</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr className="border-b border-gray-200">
                          <td className="px-4 py-3 text-gray-700">予約日の3日前23:59まで</td>
                          <td className="px-4 py-3 text-gray-700">無料（決済手数料相当額は控除）</td>
                        </tr>
                        <tr className="border-b border-gray-200">
                          <td className="px-4 py-3 text-gray-700">2日前</td>
                          <td className="px-4 py-3 text-gray-700">施術料の20％</td>
                        </tr>
                        <tr className="border-b border-gray-200">
                          <td className="px-4 py-3 text-gray-700">前日</td>
                          <td className="px-4 py-3 text-gray-700">施術料の50％</td>
                        </tr>
                        <tr>
                          <td className="px-4 py-3 text-gray-700">当日（無断来院を含む）</td>
                          <td className="px-4 py-3 text-gray-700">施術料の100％</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </li>
                <li>キャンセル料が無料の場合であっても、クレジットカード決済時に発生した決済手数料は差し引いたうえで返金します。</li>
                <li>サロンまたは DH の事情により施術日時を変更する場合、当社は速やかにユーザーへ通知し、代替予約を案内します。この場合チケットは消費されません。</li>
                <li>天災その他不可抗力により施術不能となった場合は当社基準により対応します。</li>
              </ol>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-bold text-gray-800 mb-4">第7条（ラーニングプログラム）</h2>
              <ol className="list-decimal pl-6 space-y-2 text-gray-700">
                <li>DH は、当社指定のラーニングプログラム（基礎研修・定期アップデート研修・評価テスト）を受講し、所定の合格基準を満たすことで本サービスに登録できます。</li>
                <li>ラーニングプログラムの教材・試験問題その他一切の著作物に係る知的財産権は当社に帰属します。DH は自己学習目的に限り閲覧・利用でき、第三者への開示・転用を禁止します。</li>
                <li>DH が受講した研修履歴・評価結果は、ユーザーに対する品質指標として公開されることがあります。</li>
              </ol>
            </section>

            <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-6 mt-8">
              <div className="flex items-start">
                <i className="ri-information-line text-yellow-600 text-xl mr-3 mt-1"></i>
                <div>
                  <h3 className="font-bold text-yellow-800 mb-2">利用規約について</h3>
                  <p className="text-yellow-700 text-sm">
                    本利用規約は一部のみ表示されています。完全版については、サービス開始時に詳細をご確認いただけます。
                  </p>
                </div>
              </div>
            </div>

            <section className="mb-8">
              <h2 className="text-xl font-bold text-gray-800 mb-4">第8条（報酬および収入）</h2>
              <ol className="list-decimal pl-6 space-y-2 text-gray-700">
                <li>施術料から決済手数料および当社プラットフォーム手数料（15％）を控除した残額を、サロンおよび DH に次のとおり分配します。
                  <ul className="list-disc pl-6 mt-2 space-y-1">
                    <li>サロン：5,000円／施術一律</li>
                    <li>DH：残額からサロン分を除いた金額（概ね施術料の65〜70％相当）</li>
                  </ul>
                </li>
                <li>DH がラーニングプログラムのトレーナーとして他 DH を育成した場合、当社は当該トレーナーに対し被育成 DH の施術売上の 1％を「権利収入」として追加支給します（上限 5 年間）。</li>
                <li>報酬は翌月末までに当社所定の方法で支払います。振込手数料は当社負担とします。</li>
                <li>報酬明細は DH マイページで閲覧でき、閲覧をもって受領確認とします。</li>
              </ol>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-bold text-gray-800 mb-4">第9条（ユーザーの責任）</h2>
              <ol className="list-decimal pl-6 space-y-2 text-gray-700">
                <li>健康状態・既往歴を正確に申告し、DHの指示に従ってください。虚偽申告に起因するトラブルについて当社は責任を負いません。</li>
                <li>本サービス利用に必要なデバイス・通信環境はユーザー自身の責任で整備してください。</li>
                <li>投稿コンテンツに関する著作権その他一切の権利はユーザーに留保されますが、ユーザーは当社に対し当該コンテンツを無償で利用（複製・公衆送信等）する権利を非独占的に許諾するものとします。</li>
                <li>ユーザーは、本サービスの利用を通じて得たサロン・DH・他ユーザーの情報を、本人の同意なく第三者へ提供・公開してはなりません。</li>
              </ol>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-bold text-gray-800 mb-4">第10条（禁止事項）</h2>
              <p className="text-gray-700 mb-3">ユーザーは、以下の行為をしてはなりません。</p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700">
                <li>法令・公序良俗に反する行為</li>
                <li>虚偽情報の登録・投稿</li>
                <li>他ユーザー・サロン・DH・当社への誹謗中傷、差別的表現、スパム行為</li>
                <li>施術内容を無断で録音・録画し公開する行為</li>
                <li>チケットの譲渡・転売・換金</li>
                <li>本サービスの運営・サーバーに過度な負荷を与える行為</li>
                <li>反社会的勢力への利益供与</li>
                <li>その他当社が不適切と判断する行為</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-bold text-gray-800 mb-4">第11条（利用停止・契約解除）</h2>
              <p className="text-gray-700 leading-relaxed">
                当社は、ユーザーが本規約に違反した場合、事前通知なくアカウント停止・チケット失効・予約取消し等の措置を講じることができます。当社は当該措置によりユーザーに生じた損害を賠償しません。
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-bold text-gray-800 mb-4">第12条（医療行為に関する免責）</h2>
              <ol className="list-decimal pl-6 space-y-2 text-gray-700">
                <li>本サービスはマッチングプラットフォームであり、当社自身は歯科医療行為を提供しません。</li>
                <li>医療行為に係る説明義務・同意取得・施術結果に関する責任は、施術を行う DH および所属サロンが負うものとします。当社は医療行為に起因する損害について責任を負いません。</li>
              </ol>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-bold text-gray-800 mb-4">第13条（免責）</h2>
              <ol className="list-decimal pl-6 space-y-2 text-gray-700">
                <li>当社は、サロンまたはDHが提供する施術の品質・安全性について保証しません。</li>
                <li>当社は、通信回線・システム障害等により本サービスが利用できずユーザーに損害が生じても責任を負いません。</li>
                <li>当社の責めに帰すべき事由によりユーザーに損害が発生した場合、当社の賠償責任は1万円を上限とします。ただし当社に故意または重過失がある場合はこの限りではありません。</li>
              </ol>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-bold text-gray-800 mb-4">第14条（個人情報の取扱い）</h2>
              <p className="text-gray-700 leading-relaxed">
                ユーザー情報は、当社「プライバシーポリシー」に従い適切に取り扱います。
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-bold text-gray-800 mb-4">第15条（知的財産権）</h2>
              <p className="text-gray-700 leading-relaxed">
                本サービスに関するソフトウェア・文章・画像・ロゴ等一切の知的財産権は当社またはライセンサーに帰属し、本規約に基づく利用許諾は権利譲渡を意味しません。
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-bold text-gray-800 mb-4">第16条（反社会的勢力の排除）</h2>
              <p className="text-gray-700 leading-relaxed">
                ユーザーは、自らおよび役員・実質的支配者等が反社会的勢力でないこと、またこれと取引関係を有しないことを表明し保証します。
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-bold text-gray-800 mb-4">第17条（規約の変更）</h2>
              <p className="text-gray-700 leading-relaxed">
                当社は、民法第548条の4に基づき、本規約を変更することがあります。変更の際は効力発生日を定め、適切な方法でユーザーへ周知します。ユーザーが変更後も本サービスを利用した場合、変更に同意したものとみなします。
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-bold text-gray-800 mb-4">第18条（準拠法・管轄）</h2>
              <p className="text-gray-700 leading-relaxed">
                本規約は日本法に準拠し、本サービスに関して当社とユーザーの間で生じた紛争は、東京地方裁判所を第一審の専属的合意管轄裁判所とします。
              </p>
            </section>
          </div>

          <div className="mt-12 text-center">
            <a
              href="/"
              className="inline-flex items-center px-6 py-3 bg-[#EF9786] text-white rounded-full font-semibold hover:bg-[#e8856f] transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-arrow-left-line mr-2"></i>
              ホームに戻る
            </a>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-gray-800 text-white py-12 mt-16">
        <div className="container mx-auto px-6 lg:px-20">
          <div className="grid md:grid-cols-3 gap-8">
            <div>
              <div>
                <img
                  src="https://static.readdy.ai/image/482db82fa6135662cb175aa58592a390/0f90afccf080785d3f48ab4b9d5a5a73.png"
                  alt="8028 Private Salon"
                  className="h-6 w-auto mb-4"
                />
                <p className="text-gray-400 mb-4">
                  歯の健康を守るプロと患者をつなぐプラットフォーム
                </p>
              </div>
            </div>
            <div>
              <h4 className="font-bold mb-4">会社情報</h4>
              <div className="space-y-2 text-gray-400">
                <p>運営会社：8028Global Inc</p>
                <p>お問い合わせ：support@8028private.com</p>
                <p>
                  Webサイト：
                  <a
                    href="https://8028private.com"
                    className="hover:text-white transition-colors"
                  >
                    https://8028private.com
                  </a>
                </p>
              </div>
            </div>
            <div>
              <h4 className="font-bold mb-4">リンク</h4>
              <div className="space-y-2">
                <div>
                  <a
                    href="/terms"
                    className="text-gray-400 hover:text-white transition-colors cursor-pointer"
                  >
                    利用規約
                  </a>
                </div>
                <div>
                  <a
                    href="/privacy"
                    className="text-gray-400 hover:text-white transition-colors cursor-pointer"
                  >
                    プライバシーポリシー
                  </a>
                </div>
                <div>
                  <a
                    href="/legal"
                    className="text-gray-400 hover:text-white transition-colors cursor-pointer"
                  >
                    特定商取引法に基づく表示
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="border-t border-gray-700 mt-8 pt-8 text-center text-gray-400">
            <p>&copy; 2024 8028Global Inc. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}
